export enum HeaderFlagActionTypes {
  HEADER_FLAG = "HEADER_FLAG",
}

interface HeaderFlagInAction {
  type: HeaderFlagActionTypes.HEADER_FLAG;
}

export type HeaderFlaginAction = HeaderFlagInAction;
